import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from '../models/screen-size.enum';
import { StateManagementService } from './state-management.service';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  constructor(
    private translate: TranslateService,
    private stateManagementService: StateManagementService
  ) { }

  public setupLocalization() {
    // Get the user's brand and language
    const brand = this.stateManagementService?.getUserBrand();
    // Use browser language if supported; otherwise, fallback to French
    const browserLang = navigator.language.toLowerCase();
    const supportedLangs = Object.values(LANGUAGES) as string[];
    const language: LANGUAGES = supportedLangs.includes(browserLang) ? (browserLang as LANGUAGES) : LANGUAGES.ENGLISH;
    // Update user language if not already set
    if (this.stateManagementService?.getUserLanguage() != language) {
      this.stateManagementService?.updateUserLanguage(language);
    }

    // Set translation language
    this.translate?.setDefaultLang(language);
    this.translate?.use(language);

    // Update the lang attribute on the document element
    document.documentElement?.setAttribute('lang', language);

    // Optional logging for development mode
    if (window.__dev__) {
      console.log(`Brand: ${brand}, Language: ${language}`);
    }
  }
}
